import ouiBase from '@goldwasserexchange/oui';
import { createContext } from 'react';

export const inputTypeContext = createContext<ouiBase.Input.InputTypes | null>(null);
